
import AddProformaInvoice from './AddProformaInvoice';
import ProformaInvoice from './ProformaInvoice';

const ProformaInvoiceConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/proformaInvoice',
      element: <ProformaInvoice />,
    },
    {
      path: '/addProformaInvoice',
      element: <AddProformaInvoice/>,
    },
    {
      path: '/editProformaInvoice/:id',
      element: <AddProformaInvoice/>,
    },
    
  ],
};

export default ProformaInvoiceConfig;
